module.exports = __webpack_public_path__ + "img/ganvie-20181002-juliengerard-FC330-0028.1db64e29.jpeg";